import React from 'react';
import { formatHours } from './timesheetUtils';

const cell = (value, empty = '-') => (value ? formatHours(value) : empty);

const TimesheetTable = ({
  currentWeekStart,
  formatDate,
  grouped,
  locale,
  onOpenCell,
  t,
  tableDays,
  tableTotal,
  theme,
  today,
}) => {
  const rowTotal = (byDay) => tableDays.reduce((sum, day) => sum + (byDay[day] || 0), 0);
  const columnTotal = (day) => grouped.reduce((sum, group) => sum + (group.byDay[day] || 0), 0);
  const todayClass = (day) => (day === today ? 'timesheets-table-today' : undefined);
  const canAddInCurrentWeek = (day) => day >= currentWeekStart && day <= today;

  return (
    <div className="timesheets-table-wrap">
      <table className="timesheets-table">
        <thead>
          <tr style={{ background: theme.background }}>
            <th scope="col">{t('projectTask')}</th>
            {tableDays.map((day) => (
              <th key={day} scope="col" className={todayClass(day)}>
                {new Date(`${day}T00:00`).toLocaleDateString(locale, { weekday: 'short', day: 'numeric' })}
              </th>
            ))}
            <th scope="col">{t('total')}</th>
          </tr>
        </thead>

        {grouped.map((group) => (
          <tbody key={group.project}>
            <tr className="timesheets-table-group" style={{ background: theme.background }}>
              <th scope="rowgroup">{group.project}</th>
              {tableDays.map((day) => (
                <td key={day} className={todayClass(day)}>
                  {cell(group.byDay[day], '')}
                </td>
              ))}
              <td>{formatHours(rowTotal(group.byDay))}</td>
            </tr>
            {group.tasks.map((task) => (
              <tr key={task.task}>
                <td className="timesheets-table-task">{task.task}</td>
                {tableDays.map((day) => (
                  <td key={day} className={todayClass(day)}>
                    {task.byDay[day] ? (
                      canAddInCurrentWeek(day) ? (
                        <button
                          type="button"
                          className="timesheets-cell-hours-action"
                          title={t('addTimesheet')}
                          aria-label={`${t('addTimesheet')} — ${task.task}, ${formatDate(day)}`}
                          onClick={() => onOpenCell(group.project, task.task, day)}
                        >
                          {formatHours(task.byDay[day])}
                        </button>
                      ) : (
                        formatHours(task.byDay[day])
                      )
                    ) : day > today ? (
                      <span className="timesheets-cell-disabled" aria-hidden="true">
                        -
                      </span>
                    ) : (
                      <button
                        type="button"
                        className="timesheets-cell-add"
                        title={t('addTimesheet')}
                        aria-label={`${t('addTimesheet')} — ${task.task}, ${formatDate(day)}`}
                        onClick={() => onOpenCell(group.project, task.task, day)}
                        style={{ color: theme.success }}
                      >
                        +
                      </button>
                    )}
                  </td>
                ))}
                <td>{formatHours(rowTotal(task.byDay))}</td>
              </tr>
            ))}
          </tbody>
        ))}

        <tfoot>
          <tr style={{ background: theme.background }}>
            <th scope="row">{t('total')}</th>
            {tableDays.map((day) => (
              <td key={day} className={todayClass(day)}>
                {cell(columnTotal(day), '')}
              </td>
            ))}
            <td>{formatHours(tableTotal)}</td>
          </tr>
        </tfoot>
      </table>
    </div>
  );
};

export default TimesheetTable;
